import { z } from 'zod';

import { actionIdSchema } from '../chat-ids';
import { sharedStructuredEventShape } from './shared';

export const PRESENT_CHANGE_PROPOSAL_TOOL_ID = 'presentChangeProposal';

export const changeProposalTypeSchema = z.enum([
    'update_title',
    'update_description',
    'update_tasks',
    'add_skill',
    'remove_skill',
    'adjust_skill',
    'assign_reviewer',
    'publish',
    'archive',
    'mark_reviewed',
    'generic',
]);

export type ChangeProposalType = z.infer<typeof changeProposalTypeSchema>;

export const changeProposalSchema = z.object({
    current: z.string().optional(),
    detail: z.record(z.string(), z.unknown()).optional(),
    id: actionIdSchema,
    label: z.string(),
    proposed: z.string(),
    tasks: z.array(z.string()).optional(),
    type: changeProposalTypeSchema,
});

export type ChangeProposal = z.infer<typeof changeProposalSchema>;

export const changeProposalResolutionSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('accepted') }),
    z.object({ status: z.literal('declined') }),
    z.object({ status: z.literal('suggested'), suggestion: z.string() }),
]);

export type ChangeProposalResolution = z.infer<typeof changeProposalResolutionSchema>;

export const presentChangeProposalPayloadSchema = z.object({
    blockId: z.uuid(),
    proposal: changeProposalSchema,
    resolution: changeProposalResolutionSchema.optional(),
});

export type PresentChangeProposalPayload = z.infer<typeof presentChangeProposalPayloadSchema>;

export const changeProposalResponseEventSchema = z.object({
    ...sharedStructuredEventShape,
    payload: presentChangeProposalPayloadSchema,
    toolId: z.literal(PRESENT_CHANGE_PROPOSAL_TOOL_ID),
});

export type ChangeProposalResponseEvent = z.infer<typeof changeProposalResponseEventSchema>;
